module.exports = __webpack_public_path__ + "static/media/InsuranceProbe.26eacb6b.JPG";